module.exports = __webpack_public_path__ + "img/107.português.2c02aa57.svg";